import { TemplateProperty } from 'src/lib/templates';

export const ubicationInfoTemplate: TemplateProperty[] = [
  { name: 'id', type: { name: 'string' }, optional: true },
  { name: 'state_id', type: { name: 'number' }, optional: true },
  { name: 'zip', type: { name: 'number' }, optional: true },
  { name: 'name', type: { name: 'string' }, optional: true },
  { name: 'matches', type: { name: 'array', kind: 'string' }, optional: true },
];
